import React from 'react';
import { View, ScrollView, Text, Dimensions, Platform } from 'react-native';
import { connect } from 'react-redux';
import { LineChart, BarChart } from 'react-native-chart-kit'
import ScrollViewWeb from './web/ScrollView'
import TextZ from './TextZ';

const Scroller = Platform.OS === 'web' ? ScrollViewWeb : ScrollView;


const winlossChartData = wl => {
    const data = [];
    const plain = [];
    const labels = [];
    let sum = 0;
    wl.forEach((v, i) => {
        sum += v;
        data.push(sum)
        plain.push(v)
        labels.push(`${v >= 0 ? '+':''}${v}x`)
    });
    if (data.length === 0) {
        data.push(0)
        plain.push(0)
        labels.push('0')
    }
    return {
        accu: {
            datasets: [{ data }],
            labels,
        },
        plain: {
            datasets: [{ data: plain }],
            labels,
        }
    };
}

class Component extends React.Component {
    constructor(props) {
        super(props);
        this.scroll = React.createRef();
    }


    render() {
        const { winloss, predict, results } = this.props
        const { accu, plain } = winlossChartData(winloss)
        const total = accu.datasets[0].data[accu.datasets[0].data.length - 1]

        const separator = Platform.OS === 'web' ? <span style={{color: '#777777'}}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>: '  |  ';

        let predicted = 0;
        let plus = 0;
        let minus = 0;
        let plusX = 0;
        let minusX = 0;
        let profit = 0;
        // console.log(predict)
        predict.forEach((c, i) => {
            if (c && c.match(/^[PTB]$/) && i < winloss.length) {
                if (winloss[i] > 0) {
                    plus ++;
                    plusX += winloss[i];
                }
                if (winloss[i] < 0) {
                    minus ++;
                    minusX += -winloss[i];
                }
    
                profit += winloss[i];
                predicted ++
            }
        });

        return <View style={{
            flexDirection: 'column',
            backgroundColor: "rgba(0,0,0,0.7)",
        }}>
            <TextZ style={{
                color: "#ffffff",
                textAlign: "center"
            }}>
                สูตรทำนาย: {predicted}&nbsp; ไม้ {separator}
                บวก: x{plusX}&nbsp; {separator}
                ลบ: x{minusX}&nbsp; {separator}
                {profit >= 0 ? 'กำไร': 'ขาดทุน'} : {profit >= 0 ? '+': ''}x{profit}
            </TextZ>

            <Scroller
                horizontal={true}
                ref={this.scroll} 
                onContentSizeChange={(contentWidth, contentHeight)=>{        
                    this.scroll.current.scrollToEnd({animated: true});
                }}>
                <View style={{
                    width: Math.max(Dimensions.get("window").width, winloss.length * 20),
                    flexDirection: 'column'
                }}>
                    <LineChart
                        backgroundColor="#ff0000"
                        //width={Dimensions.get("window").width}
                        width={Math.max(Dimensions.get("window").width, winloss.length * 20)}
                        data={accu}
                        height={170}
                        yAxisSuffix={"x"}
                        // verticalLabelRotation={-30}
                        chartConfig={{
                            backgroundGradientFrom: "#004400",
                            backgroundGradientFromOpacity: 1,
                            backgroundGradientTo: "#000000",
                            backgroundGradientToOpacity: 1,
                            bacgroundColor: 'red',

                            decimalPlaces: 0, // optional, defaults to 2dp
                            color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                            labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                            fontSize: 10,
                            propsForDots: {
                            r: "3",
                            strokeWidth: "1",
                            stroke: "#ffa726"
                            },
                            propsForLabels: {
                                ...(Platform.OS === 'web'? {} : {marginLeft: -100}),
                                fontSize: 12
                            }
                        }}
                        bezier
                        style={{
                            marginVertical: 4,
                            borderRadius: 0,
                            backgroundColor: "red",
                        }}
                    >
                    </LineChart>
                </View>
            </Scroller>
        </View>
    }
}


const mapStateToProps = state => {
    return {
        winloss: state.results.winloss,
        predict: state.results.predict,
        results: state.results.results,
    };
};

export default connect(mapStateToProps)(Component);

 